module.exports = __webpack_public_path__ + "pin_darkgrey.a17fd5.png";